module.exports = __webpack_public_path__ + "img/icn_back.c43c426e.svg";